import React, { useContext } from "react";
import { Route } from "@mui/icons-material";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";
import { useLayerEditable } from "./useLayerEditable";

const ShortestPathButton: React.FC<IButtonProps> = ({ icon, title = "Draw shortest path", ...rest }) => {
  const { map, drawControl } = useContext(MapContext);
  const isLayerEditable = useLayerEditable();

  const handleOnClick = () => {
    if (!drawControl.current) return;
    drawControl.current.changeMode("shortest_path_feature");
    map?.fire("draw.modechange", { type: "draw.modechange", mode: "shortest_path_feature" });
  };

  return (
    <ToolbarToggleButton
      title={title}
      {...rest}
      value="shortest_path_feature"
      onClick={handleOnClick}
      data-testid="toolbar-shortest-path-button"
      disabled={!isLayerEditable}
    >
      {icon || <Route />}
    </ToolbarToggleButton>
  );
};

export default ShortestPathButton;
